import Head from 'next/head'

import { LS_APP_DOMAIN } from 'config/constants'

const MetaTags = ({ resolvedUrl, album, photoClassifications }) => {
  const photo = album?.frontCover

  const pathName = resolvedUrl.split('?')[0]
  const photoIdQs = photo?.urlId || ''
  const path =
    `${LS_APP_DOMAIN + pathName}` + (photoIdQs ? `?photoId=${photoIdQs}` : '')

  const title = album?.name ? `${album.name}－信義居家` : '信義居家'

  const keywords = album?.keywords?.map((keyword) => keyword.name).join(',')

  const spaceClassification = photoClassifications?.find(
    (classification) => classification.name === '空間'
  )
  const styleClassification = photoClassifications?.find(
    (classification) => classification.name === '風格'
  )

  const spaceTags = spaceClassification?.tags?.filter((tag) =>
    photo?.tags?.find((photoTag) => photoTag.urlId === tag.urlId)
  )
  const styleTags = styleClassification?.tags?.filter((tag) =>
    photo?.tags?.find((photoTag) => photoTag.urlId === tag.urlId)
  )
  const spaceTagNames = spaceTags?.map((tag) => tag.name)?.join('、')
  const styleTagNames = styleTags?.map((tag) => tag.name)?.join('、')

  let description = `${album?.name}，信義居家這次蒐集的設計案例是${spaceTagNames}規劃，採用${styleTagNames}作空間風格主調，趕緊來一起看看該怎麼為${spaceTagNames}做出完美設計吧！`

  const breadcrumbData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首頁',
        item: 'https://livinglife.com.tw',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '裝修圖輯',
        item: 'https://livinglife.com.tw/album',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: album?.name,
        item: path,
      },
    ],
  }

  return (
    <Head>
      <title>{title}</title>

      <link key="canonical" rel="canonical" href={path} />

      {/* For Google */}
      <meta key="title" name="title" content={title} />
      <meta key="description" name="description" content={description} />
      <meta key="keywords" name="keywords" content={keywords} />
      <meta
        key="copyright"
        name="copyright"
        content="本網頁著作權屬信義房屋股份有限公司, All Rights Reserved"
      />
      <meta
        key="application-name"
        name="application-name"
        content="信義居家好生活"
      />

      {/* For Facebook */}
      <meta key="og:title" property="og:title" content={title} />
      <meta
        key="og:description"
        property="og:description"
        content={description}
      />
      <meta
        key="og:image"
        property="og:image"
        content={photo?.image?.url || ''}
      />
      <meta key="og:url" property="og:url" content={path} />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
      />
    </Head>
  )
}

export default MetaTags
